"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _reactRouterDom = require("react-router-dom");
var _FlatButton = _interopRequireDefault(require("material-ui/FlatButton"));
var _RadioButton = require("material-ui/RadioButton");
var _MenuItem = _interopRequireDefault(require("material-ui/MenuItem"));
var _chevronRight = _interopRequireDefault(require("material-ui/svg-icons/navigation/chevron-right"));
var _Accordion = _interopRequireDefault(require("../Accordion"));
var _Select = _interopRequireDefault(require("../Select"));
var _Slider = _interopRequireDefault(require("../Slider"));
var _MultiForm = _interopRequireDefault(require("../MultiForm"));
var _PopupList = _interopRequireDefault(require("../PopupList"));
var _PopupListWithFilter = _interopRequireDefault(require("../PopupListWithFilter"));
var _InputText = _interopRequireDefault(require("../InputText"));
var _Toggle = _interopRequireDefault(require("../Toggle"));
var _LabelInfo = _interopRequireDefault(require("../LabelInfo"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _PartialDate = _interopRequireDefault(require("../PartialDate"));
var _QuillRTE = _interopRequireDefault(require("../QuillRTE"));
var _AssetListEditor = _interopRequireDefault(require("../AssetListEditor"));
var _Chooser = _interopRequireDefault(require("../Chooser"));
var _ThumbSelect = _interopRequireDefault(require("../ThumbSelect"));
require("./List.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); } // import ColorPicker from "../ColorPicker";
var ListItem = /*#__PURE__*/function (_Component) {
  _inherits(ListItem, _Component);
  var _super = _createSuper(ListItem);
  function ListItem(props) {
    var _this;
    _classCallCheck(this, ListItem);
    _this = _super.call(this, props);
    _this.state = {
      data: props.data ? props.data : ""
    };
    if (document) {
      _this.quill = require("react-quill");
    }
    return _this;
  }
  _createClass(ListItem, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        data: nextProps.data
      });
    }
  }, {
    key: "generateLabel",
    value: function generateLabel(labelText, infoText, isRequired) {
      var addRequired = typeof isRequired !== "undefined" ? isRequired : false;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "label-container"
      }, /*#__PURE__*/_react["default"].createElement("span", null, labelText, " ", addRequired ? /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: "red"
        }
      }, "*") : null), infoText ? /*#__PURE__*/_react["default"].createElement(_LabelInfo["default"], {
        info: infoText
      }) : null);
    }
  }, {
    key: "generateTwoColumns",
    value: function generateTwoColumns(Component, props, label) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-12 cms-list-item"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-6 left-item"
      }, props.icon ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "icon-container",
        style: this.props.styleName === "boxed" ? {
          background: this.props.muiTheme.palette.primary1Color
        } : null
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: props.icon,
        width: 20,
        style: {
          "float": "left",
          marginRight: 10
        }
      })) : null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "list-item-text"
      }, label)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-6 right-item"
      }, /*#__PURE__*/_react["default"].createElement(Component, props)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        icon = _this$props.icon,
        item = _this$props.item,
        slugBase = _this$props.slugBase,
        handleInputChange = _this$props.handleInputChange,
        muiTheme = _this$props.muiTheme,
        needRefresh = _this$props.needRefresh,
        styleName = _this$props.styleName;
      var data = this.state.data;
      if (!item) return /*#__PURE__*/_react["default"].createElement("div", null);
      var param = item.param; // This does not seem to work, param == undefinded
      switch (item.type) {
        case "section":
        case "link":
          item.slug = item.slug.search(slugBase) === -1 ? slugBase + "/" + item.slug : item.slug;
          //const linkClick = ()=>{navigateTo(item.slug)}
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "cms-list-item link ".concat(styleName)
          }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
            to: item.slug,
            className: "cms-list-item-container",
            activeClassName: "active"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "col-sm-12 cms-list-item link"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "col-sm-7 left-item"
          }, item.icon ? /*#__PURE__*/_react["default"].createElement("div", {
            className: "icon-container",
            style: styleName === "boxed" ? {
              background: muiTheme.palette.primary1Color
            } : null
          }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            icon: item.icon,
            width: 20,
            style: {
              "float": "left",
              marginRight: 10
            }
          })) : null, /*#__PURE__*/_react["default"].createElement("div", {
            className: "list-item-text"
          }, item.label, " "), item.sublabel ? /*#__PURE__*/_react["default"].createElement("div", {
            className: "list-item-sublabel"
          }, item.sublabel, " ") : null), /*#__PURE__*/_react["default"].createElement("div", {
            className: "col-sm-5 right-item"
          }, /*#__PURE__*/_react["default"].createElement(_chevronRight["default"], null)))));
        case "accordion":
          return /*#__PURE__*/_react["default"].createElement(_Accordion["default"], item);
        case "navigate":
          var navClick = function navClick() {
            _this2.props.history.push(item.to || item.slug);
          };
          var leftIcon = icon ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            icon: icon,
            width: 20,
            style: {
              "float": "left",
              marginRight: 10
            }
          }) : {};
          return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
            to: item.to || item.slug,
            className: "cms-list-item navigate-link ".concat(styleName)
          }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
            className: "navigate-item",
            onClick: navClick,
            leftIcon: leftIcon,
            primaryText: item.label,
            rightIcon: /*#__PURE__*/_react["default"].createElement(_chevronRight["default"], null)
          }));
        case "button":
          var buttonClick = item.onClick ? item.onClick : function () {
            _this2.props.history.push(item.to);
          };
          return /*#__PURE__*/_react["default"].createElement(_FlatButton["default"], _extends({}, item, {
            onClick: buttonClick
          }));
        case "divider":
          //return <ItemDivider {...item} />;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "list-group-header ".concat(className)
          }, item.showLine ? /*#__PURE__*/_react["default"].createElement("hr", {
            className: "cms-list-border"
          }) : null, item.label ? /*#__PURE__*/_react["default"].createElement("h2", null, item.label) : null);
        default:
          var value = data !== undefined ? data : item.value ? item.value : "";
          var label = this.generateLabel(item.label, item.infoText, item.isRequired);
          var options = item.options,
            inlineLabel = item.inlineLabel;
          var myProps = {};
          switch (item.inputType || item.type) {
            /**
             * @NOTE: ColorPicker is originating problems - disabled until we can look into it
             */
            // case 'color':
            //   myProps = {
            //     colorValue: value,
            //     onChange: handleInputChange,
            //     dataProperty: param,
            //     needRefresh: needRefresh
            //   };
            //   if (inlineLabel)
            //     return ( <ColorPicker {...myProps} label={label}/>);
            //
            //   return generateTwoColumns(ColorPicker, myProps, label);
            case "select":
            case "select-multiple":
              var generateOption = function generateOption(labelPrefix, valuePrefix) {
                return function (i) {
                  return {
                    label: labelPrefix ? "".concat(labelPrefix).concat(i) : "".concat(i),
                    value: valuePrefix ? "".concat(valuePrefix).concat(i) : i
                  };
                };
              };
              var selectOptions = item.optionsRange ? item.optionsRangeZeroBased ? _toConsumableArray(Array(item.optionsRange + 1).keys()).map(generateOption(item.optionsRangeLabelPrefix, item.optionsRangeValuePrefix)) : Array.from({
                length: item.optionsRange
              }, function (_, i) {
                return i + 1;
              }).map(generateOption(item.optionsRangeLabelPrefix, item.optionsRangeValuePrefix)) : options;

              // the value will be the INDEX of the options that the value from db matches
              var selectedIndex = (0, _findIndex2["default"])(selectOptions, {
                value: value
              });
              myProps = {
                options: selectOptions,
                styleName: styleName,
                selected: selectedIndex,
                value: value,
                hasLabel: !!item.label,
                onChange: handleInputChange,
                dataProperty: param,
                needRefresh: needRefresh,
                multiple: item.type === "select-multiple" ? true : false
              };
              if (inlineLabel) return /*#__PURE__*/_react["default"].createElement(_Select["default"], _extends({}, myProps, {
                floatingLabel: label
              }));
              return this.generateTwoColumns(_Select["default"], myProps, label);
            case "thumbSelect":
              var generateOption2 = function generateOption2(valuePrefix) {
                return function (i) {
                  return {
                    value: valuePrefix ? "".concat(valuePrefix).concat(i) : i,
                    _id: i
                  };
                };
              };
              var thumbSelectOptions = item.optionsRange ? item.optionsRangeZeroBased ? _toConsumableArray(Array(item.optionsRange + 1).keys()).map(generateOption2(item.optionsRangeValuePrefix)) : Array.from({
                length: item.optionsRange
              }, function (_, i) {
                return i + 1;
              }).map(generateOption2(item.optionsRangeValuePrefix)) : item.options;
              myProps = {
                id: param,
                name: param,
                className: className || param,
                options: thumbSelectOptions,
                selected: value,
                onChange: handleInputChange,
                component: item.component
              };
              if (inlineLabel) return /*#__PURE__*/_react["default"].createElement(_ThumbSelect["default"], _extends({}, myProps, {
                label: label
              }));
              return this.generateTwoColumns(_ThumbSelect["default"], myProps, label);
            case "slider":
              myProps = {
                styleName: styleName,
                hasLabel: !!item.label,
                min: item.min,
                max: item.max,
                value: value,
                onChange: handleInputChange,
                dataProperty: param,
                needRefresh: needRefresh
              };
              if (inlineLabel) return /*#__PURE__*/_react["default"].createElement(_Slider["default"], _extends({}, myProps, {
                label: label
              }));
              return this.generateTwoColumns(_Slider["default"], myProps, label);
            case "toggle":
              myProps = {
                toggled: value,
                name: item.param,
                styleName: styleName,
                hasLabel: !!item.label,
                onChange: handleInputChange,
                dataProperty: param,
                needRefresh: needRefresh
              };
              if (inlineLabel) return /*#__PURE__*/_react["default"].createElement(_Toggle["default"], _extends({}, myProps, {
                label: label
              }));
              return this.generateTwoColumns(_Toggle["default"], myProps, label);
            case "radio":
              myProps = {};
              return /*#__PURE__*/_react["default"].createElement("div", {
                className: "cms-input-text radio"
              }, label ? label : null, /*#__PURE__*/_react["default"].createElement(_RadioButton.RadioButtonGroup, {
                name: item.param,
                valueSelected: value,
                onChange: handleInputChange
              }, (0, _map2["default"])(options, function (subitem) {
                return /*#__PURE__*/_react["default"].createElement(_RadioButton.RadioButton, {
                  value: subitem.value,
                  key: subitem.value,
                  label: subitem.label,
                  style: subitem.style
                });
              })));
            case "checkbox":
              myProps = {
                valueFromInput: value,
                key: item.param,
                styleName: styleName,
                hasLabel: !!item.label,
                label: label,
                onChange: handleInputChange,
                dataProperty: param,
                needRefresh: needRefresh,
                labelPosition: inlineLabel ? "left" : "right"
              };
              return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], myProps);
            case "popupList":
              //const popListIndex = _findIndex(options, {'value': value});selected:popListIndex,
              myProps = {
                options: options,
                onChange: handleInputChange,
                value: value,
                classId: item.classId,
                dataProperty: param
              };
              if (inlineLabel) return /*#__PURE__*/_react["default"].createElement(_PopupList["default"], _extends({}, myProps, {
                label: label
              }));
              return this.generateTwoColumns(_PopupList["default"], myProps, label);
            case "multiForm":
              myProps = {
                options: options,
                styleName: styleName,
                injectLanguage: this.props.injectLanguage,
                language: this.props.language,
                handleEditClick: item.handleEditClick ? item.handleEditClick : this.props.handleEditClick,
                handleAddClick: item.handleAddClick ? item.handleAddClick : this.props.handleAddClick,
                handleDeleteClick: item.handleDeleteClick ? item.handleDeleteClick : this.props.handleDeleteClick,
                handleInputChange: handleInputChange,
                list: value ? value.list ? value.list : value : null,
                param: param,
                classId: item.classId,
                dataProperty: param
              };
              return /*#__PURE__*/_react["default"].createElement(_MultiForm["default"], _extends({}, myProps, {
                label: label
              }));
            case "popupListWithFilter":
              var popListFilterIndex = (0, _findIndex2["default"])(options, {
                value: value
              });
              myProps = {
                options: options,
                onChange: handleInputChange,
                selectedIndex: popListFilterIndex,
                selectedValue: value,
                classId: item.classId,
                dataProperty: param,
                needRefresh: needRefresh
              };
              if (inlineLabel) return /*#__PURE__*/_react["default"].createElement(_PopupListWithFilter["default"], _extends({}, myProps, {
                label: label
              }));
              return this.generateTwoColumns(_PopupListWithFilter["default"], myProps, label);
            case "rte":
              myProps = {
                id: item.label,
                name: param,
                theme: "bubble",
                styleName: styleName,
                hasLabel: !!item.label,
                defaultValue: value,
                onChange: handleInputChange,
                key: param || item.label,
                toolbarType: item.inputType || item.type
              };
              return /*#__PURE__*/_react["default"].createElement(_QuillRTE["default"], _extends({}, myProps, {
                label: label
              }));
            case "rte-ext":
            case "rte-ext-class":
              myProps = {
                id: item.label,
                name: param,
                theme: "snow",
                styleName: styleName,
                hasLabel: !!item.label,
                defaultValue: value,
                onChange: handleInputChange,
                key: param || item.label,
                toolbarType: item.inputType || item.type
              };
              return /*#__PURE__*/_react["default"].createElement(_QuillRTE["default"], _extends({}, myProps, {
                label: label
              }));
            case "partialDate":
              myProps = {
                id: item.label,
                name: param,
                styleName: styleName,
                hasLabel: !!item.label,
                value: value,
                handleInputChange: handleInputChange,
                key: param || item.label
              };
              return /*#__PURE__*/_react["default"].createElement(_PartialDate["default"], _extends({}, myProps, {
                label: label
              }));
            case "assetEditor":
              myProps = _objectSpread({
                styleName: styleName,
                hasLabel: !!item.label,
                label: label,
                handleEditClick: item.handleEditClick ? item.handleEditClick : this.props.handleEditClick,
                handleAddClick: item.handleAddClick ? item.handleAddClick : this.props.handleAddClick,
                handleDeleteClick: item.handleDeleteClick ? item.handleDeleteClick : this.props.handleDeleteClick,
                handleFrameSetterFunc: item.handleFrameSetterFunc ? item.handleFrameSetterFunc : this.props.handleFrameSetterFunc,
                param: param
              }, value);
              if (typeof this.props.row !== "undefined") {
                myProps.row = this.props.row;
              }
              return /*#__PURE__*/_react["default"].createElement(_AssetListEditor["default"], myProps);
            case "readonly":
              myProps = {
                id: item.label,
                name: param,
                hasLabel: !!item.label,
                dataProperty: param,
                defaultValue: value,
                onChange: handleInputChange,
                styleName: styleName,
                multiLine: item.type === "textarea",
                key: param || item.label,
                needRefresh: needRefresh,
                disabled: true
              };
              if (inlineLabel) return /*#__PURE__*/_react["default"].createElement(_InputText["default"], _extends({}, myProps, {
                label: label
              }));
              return this.generateTwoColumns(_InputText["default"], myProps, label);
            case "password":
              myProps = {
                id: item.label,
                name: param,
                hasLabel: !!item.label,
                dataProperty: param,
                defaultValue: value,
                onChange: handleInputChange,
                styleName: styleName,
                multiLine: item.type === "textarea",
                key: param || item.label,
                needRefresh: needRefresh,
                type: "password",
                autoComplete: "off"
              };
              if (inlineLabel) return /*#__PURE__*/_react["default"].createElement(_InputText["default"], _extends({}, myProps, {
                label: label
              }));
              return this.generateTwoColumns(_InputText["default"], myProps, label);
            case "chooser":
              return /*#__PURE__*/_react["default"].createElement(_Chooser["default"], {
                thumbCloudPublicId: value.thumbCloudPublicId,
                cloudName: value.cloudName,
                title: value.title,
                actionLabel: item.actionLabel,
                actionOnClick: item.handleActionClick
              });
            default:
              var multiLine = item.type === "textarea";
              myProps = {
                id: item.label,
                hasLabel: !!item.label,
                name: param,
                styleName: styleName,
                disabled: typeof item.disabled === "undefined" ? undefined : item.disabled,
                dataProperty: param,
                defaultValue: value,
                onChange: handleInputChange,
                multiLine: multiLine,
                key: param || item.label,
                needRefresh: needRefresh,
                autoComplete: item.autoComplete
              };
              if (inlineLabel) return /*#__PURE__*/_react["default"].createElement(_InputText["default"], _extends({}, myProps, {
                label: label
              }));
              return this.generateTwoColumns(_InputText["default"], myProps, label);
          }
      }
    }
  }]);
  return ListItem;
}(_react.Component);
ListItem.defaultProps = {
  needRefresh: false,
  styleName: "standard"
};
ListItem.propTypes = {
  handleInputChange: _propTypes["default"].func,
  icon: _propTypes["default"].string,
  item: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  muiTheme: _propTypes["default"].object,
  // Object inheriting Material UI Context styles
  needRefresh: _propTypes["default"].bool,
  toggleNeedRefresh: _propTypes["default"].func,
  styleName: _propTypes["default"].string,
  slugBase: _propTypes["default"].string,
  injectLanguage: _propTypes["default"].bool,
  language: _propTypes["default"].string,
  handleEditClick: _propTypes["default"].func,
  handleAddClick: _propTypes["default"].func,
  handleDeleteClick: _propTypes["default"].func,
  handleFrameSetterFunc: _propTypes["default"].func,
  row: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  // For multiForm we need to pass the row number for the action handlers
  data: _propTypes["default"].any
};
var _default = (0, _reactRouterDom.withRouter)(ListItem);
exports["default"] = _default;